<template>
  <nav class="nav">
    <ul class="nav-menu">
      <router-link 
        v-for="(item, index) in navList" 
        :key="index" 
        :to="item.path">
        <li
          class="nav-menu-item"
          :class="activeName === item.name ? 'active-title' : 'normal-title'"
        >
          {{item.text}}
        </li>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    navList: Array,
  },
  computed: {
    activeName() {
      return this.$route.name
    }
  },
  methods: {}
}
</script>
<style scoped>
.nav-menu {
  display: flex;
  align-items: baseline;
}
.nav-menu-item {
  color: rgba(51, 51, 51, .7);
  margin: 0 0 0 60px;
  cursor: pointer;
  transition: all .2s linear;
}
.nav-menu-item:hover{
  color: #3B84D8;
}
.active-title {
  font-size: 24px;
  font-weight: 600;
  color: rgb(22, 73, 105);
}
.normal-title {
  font-size: 16px;
  font-weight: 400;
}
</style>